// extracted by mini-css-extract-plugin
export var accountContent = "pass-change-module--account-content--KGTVk";
export var passChangeWrapper = "pass-change-module--pass-change-wrapper--XHjtS";
export var sectionHeader = "pass-change-module--section-header--ROzE0";
export var sectionHeaderDescription = "pass-change-module--section-header-description--M8JqS";
export var sectionHeaderTitle = "pass-change-module--section-header-title--NkU68";
export var titleText = "pass-change-module--title-text--8x-5i";